<template>
	<v-footer
		app
		padless
		color="transparent"
		class="footer-nav px-4 pt-1"
	>
		<v-sheet
			outlined
			rounded="pill"
			width="100%"
			class="footer-nav__bar d-flex align-center pa-1"
		>
			<router-link
				v-for="item in items"
				:key="item.name"
				:to="{ name: item.name }"
				class="footer-nav__item d-flex align-center justify-center rounded-pill text-decoration-none"
				:class="isActive(item.name) ? 'footer-nav__item--active primary white--text px-4' : ''"
			>
				<v-icon
					size="20"
					:color="isActive(item.name) ? 'white' : 'grey darken-3'"
				>{{ item.icon }}</v-icon>
				<span class="footer-nav__label text-caption font-weight-bold">{{ $T(item.label) }}</span>
			</router-link>
		</v-sheet>
	</v-footer>
</template>

<script>
import { usePlans } from '@/configs/general.configs'
export default {
	name: 'FooterNavigation',
	computed: {
		items() {
			return [
				{ name: 'visits', label: 'routes.visits', icon: 'mdi-calendar-check-outline' },
				...(usePlans ? [{ name: 'plans', label: 'routes.plans', icon: 'mdi-clipboard-edit-outline' }] : []),
				{ name: 'customers', label: 'routes.customers', icon: 'mdi-account-group-outline' },
				{ name: 'products', label: 'routes.products', icon: 'mdi-package-variant-closed' },
				{ name: 'expenses', label: 'routes.expenses', icon: 'mdi-wallet-outline' },
			]
		},
	},
	methods: {
		isActive(name) {
			return this.$route.name === name
		},
	},
}
</script>

<style lang="scss" scoped>
.footer-nav{
	padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
}

.footer-nav__bar{
	min-height: 52px;
}

.footer-nav__item{
	flex: 1 1 0;
	min-width: 0;
	height: 40px;
	transition: background-color .25s ease, flex-grow .25s ease, padding .25s ease;

	&--active{
		flex-grow: 2.4;
	}
}

.footer-nav__label{
	max-width: 0;
	margin-inline-start: 0;
	opacity: 0;
	line-height: 1;
	white-space: nowrap;
	overflow: hidden;
	transition: max-width .25s ease, margin .25s ease, opacity .2s ease;

	.footer-nav__item--active &{
		max-width: 140px;
		margin-inline-start: 8px;
		opacity: 1;
	}
}
</style>
